
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import classnames from 'classnames'
import WithTooltip from 'components/WithTooltip'

export default class ChannelIcon extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    group: PropTypes.string,
    active: PropTypes.bool,
    className: PropTypes.string,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    onClick: PropTypes.func,
    tooltip: PropTypes.string,
    size: PropTypes.string,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    size: '14px'
  }

  render() {
    const {
      name,
      group,
      active,
      className,
      onMouseOver,
      onMouseOut,
      onClick,
      size,
      tooltip,
      disabled
    } = this.props
    const classNames = classnames('channel-icon', className, {
      [`is-${group}`]: !disabled && group,
      'is-active': !disabled && active,
      'is-disabled': disabled
    })

    return (
      <WithTooltip place='top' style='blue' title={tooltip}>
        <div
          className={classNames}
          onMouseEnter={onMouseOver}
          onMouseLeave={onMouseOut}
          onClick={onClick}
        >
          {!disabled ? <Icon
            className='channel-icon_icon'
            name={`channel-${name}`}
            size={size}
          /> : null}
        </div>
      </WithTooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/ChannelIcon/index.js